const regionalMixinsPlugin = {
  install(vue) {
    vue.mixin({
      beforeCreate() {
        const { regionalMixins } = this.$options;

        if (regionalMixins && regionalMixins.length) {
          regionalMixins.forEach((mixin) => { this.$options = vue.util.mergeOptions(this.$options, mixin, this); });
        } else {
          let parent = this.$parent;

          while (parent) {
            const mixins = parent.$options?.regionalMixins || [];

            mixins.forEach((mixin) => {
              this.$options = vue.util.mergeOptions(this.$options, mixin, this);
            });

            parent = parent.$parent;
          }
        }
      },
    });
  },
};

export default regionalMixinsPlugin;
